import React from 'react';
import styled from 'styled-components';
import { HideFor, ShowFor } from '@zocdoc-frontend-common/styles-grid';
import { columnSize } from '@zocdoc-frontend-common/styles-grid';
import { ProcedureDropdown } from '@zocdoc-frontend-common/components-proceduredropdown';
import { Tooltip, TOOLTIP } from '@zocdoc-frontend-common/components-tooltip';

import { APPOINTMENT_INFO_STRINGS } from '../../pages/AppointmentInfo/constants';

const ProcedureDropdownWithTooltip = ({ providerId, selected }) => {
    const tooltipAnchor = (
        <ProcedureDropdown providerId={providerId} selected={selected} />
    );
    return (
        <div>
            <HideForDesktop>
                <StyledTooltip
                    anchor={tooltipAnchor}
                    data-test="mobile-only"
                    showTooltip
                    showTooltipOnFocus
                    showTooltipOnHover
                    tooltipPosition={TOOLTIP.BOTTOM}
                >
                    {APPOINTMENT_INFO_STRINGS.ProcedureMayNotBeCovered}
                </StyledTooltip>
            </HideForDesktop>
            <HideFor xsmall xxsmall>
                <StyledTooltip
                    anchor={tooltipAnchor}
                    data-test="desktop-only"
                    showTooltip
                    showTooltipOnFocus
                    showTooltipOnHover
                    tooltipPosition={TOOLTIP.RIGHT}
                >
                    {APPOINTMENT_INFO_STRINGS.ProcedureMayNotBeCovered}
                </StyledTooltip>
            </HideFor>
        </div>
    );
};

export const StyledTooltip = styled(Tooltip)`
    margin-left: 50%;
    transform: translateX(-50%);
    width: 250px;
`;

const HideForDesktop = styled(ShowFor).attrs({
    xxsmall: true,
    xsmall: true,
})`
    ${columnSize(24)};
    margin-bottom: 104px;
`;

export default ProcedureDropdownWithTooltip;
